<!--大用户 - 用户管理 - 大用户列表 -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="48">
          <!-- 第一排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="所属片区">
              <a-select v-model="query.belongingArea" placeholder="请选择所属片区" allow-clear>
                <a-select-option v-for="(value, index) in zoneOptionList" :key="index" :value="value">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编码">
              <a-input v-model="query.userCode" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="手机号码">
              <a-input v-model="query.phone" placeholder="请输入手机号码" allow-clear />
            </a-form-item>
          </a-col>
          <!-- 第二排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="水表编号">
              <a-input v-model="query.waterMeterNumber" placeholder="请输入水表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="口径">
              <a-input v-model="query.caliber" placeholder="请输入口径" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表类型">
              <a-select v-model="query.waterMeterType" placeholder="请选择水表类型" allow-clear style="width: 100%;">
                <a-select-option :value="1">机械表</a-select-option>
                <a-select-option :value="2">远传表</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用水性质">
              <a-select v-model="query.waterType" placeholder="请选择用水性质" allow-clear>
                <a-select-option :value="1">居民用水</a-select-option>
                <a-select-option :value="2">非居民用水</a-select-option>
                <a-select-option :value="3">特种用水</a-select-option>
                <a-select-option :value="4">其他用水</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 第三排-操作按钮 -->
          <a-col :md="12" :sm="12" style="display: flex;">
            <div style="margin-bottom: 20px;">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="alarmSettingsList"
                v-action:settings>统一报警设置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="exportHandles()" v-action:export>导出</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 1500 }">
      <span slot="caliber" slot-scope="text">
        DN{{ text }}
      </span>

      <span slot="action" slot-scope="text, record">
        <a @click="alarmSettingsById(record)" v-action:settings>报警设置</a>
        <a-divider type="vertical" />
        <a @click="userInfoById(record)">用水详情</a>
      </span>
    </a-table>

    <!-- 报警设置 -->
    <a-modal title="报警设置" :dialog-style="{ top: '240px' }" :width="600" :maskClosable="false"
      v-model="alarmSettingsVisible" @ok="alarmSettingsOk" @cancel="handleCancel">
      <div>
        <span class="proportion">比例设置:</span>
        <a-form :form="addOrUpdateForm" class="tenant-form">
          <a-row class="form-row" :gutter="16">
            <!-- 正波动报警比例 -->
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="正波动报警比例">
                <a-input placeholder="请输入正波动报警比例" type="number" min="0" style="width: 100%;margin-left: 10px;"
                  v-decorator="['positiveFluctuations', {
                    rules: [
                      { pattern: /^[1-9]\d*$/, message: '请输入正整数' }
                    ]
                  }]" @keypress="handleKeyPress" />
              </a-form-item>
            </a-col>
            <!-- 反波动报警比例 -->
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="反波动报警比例">
                <a-input placeholder="请输入反波动报警比例" type="number" min="0" style="width: 100%; margin-left: 10px;"
                  v-decorator="['antiVolatility', {
                    rules: [
                      { pattern: /^[1-9]\d*$/, message: '请输入正整数' }
                    ]
                  }]" @keypress="handleKeyPress" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import mixinViewModule from '@/mixin/common' //选项式混合导入
const columns = [ //表头参数
  {
    title: '用户编码',
    dataIndex: 'userCode',
    width: '120px', // 固定操作列宽度
    fixed: 'left'
  },
  {
    title: '用户名称',
    dataIndex: 'userName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '水表编号',
    dataIndex: 'waterMeterNumber',
    width: '150px',
    ellipsis: true
  },
  {
    title: '用户地址',
    dataIndex: 'userAddress',
    width: '200px',
    ellipsis: true
  },
  {
    title: '用水性质',
    dataIndex: 'waterTypeName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '手机号码',
    dataIndex: 'phone',
    width: '150px',
    ellipsis: true
  },
  {
    title: '所属片区',
    dataIndex: 'belongingArea',
    width: '150px',
    ellipsis: true
  },
  {
    title: '水表类型',
    dataIndex: 'waterMeterTypeName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '口径',
    dataIndex: 'caliber',
    width: '100px',
    ellipsis: true,
    scopedSlots: { customRender: 'caliber' }
  },
  {
    title: '厂家',
    dataIndex: 'manufacturer',
    width: '150px',
    ellipsis: true
  },
  {
    title: '安装日期',
    dataIndex: 'installDate',
    width: '150px',
    ellipsis: true
  },
  {
    title: '入选时间',
    dataIndex: 'voteTime',
    width: '180px',
    ellipsis: true
  },
  {
    title: '经度',
    dataIndex: 'longitude',
    width: '150px',
    ellipsis: true
  },
  {
    title: '纬度',
    dataIndex: 'latitude',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: '180px', // 固定操作列宽度
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'BigUserPage',
  data () {
    return {
      labelCol: { span: 10 },
      wrapperCol: { span: 12 },
      //needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      //通用接口
      getZoneListUrl: '/smart-water-major-users/major/users/user/group/belonging_area/select', //获取片区列表
      zoneOptionList: [], //片区列表
      //页面接口
      queryUrl: '/smart-water-major-users/major/users/user/page/select', //查询url
      addOrUpdateUrl: '/smart-water-major-users/major/users/user/user_info/list/update', //新增or编辑url
      exportDataUrl: 'smart-water-major-users/major/users/user/user_info/big/list/export', //导出url
      exportFileName: '大用户列表.xlsx', //导出名称
      query: { //查询对象
        'ifLargeUsers': 2
      },
      id: '',
      alarmSettings: null,
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      //页面内属性
      alarmSettingsVisible: false, //报警设置
      userData: {}, //用户信息
    }
  },
  computed: {
    hasUserData () {
      return this.userData && Object.keys(this.userData).length > 0;
    }
  },

  mounted () {
    this.getZoneList();
  },
  methods: {
    // 阻止输入减号等非法字符
    handleKeyPress (e) {
      // 获取按键的字符码
      const charCode = e.charCode || e.which || e.keyCode;
      // 只允许数字字符 (0-9)
      if (charCode < 48 || charCode > 57) {
        e.preventDefault();
        return false;
      }
    },
    //设置页面名称
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}大用户列表`)
    },
    getZoneList () {
      this.$http.get(this.getZoneListUrl).then((res) => {
        this.zoneOptionList = res.data
      })
    },
    // 重置
    resetList () {
      this.pagination.current = 1
      this.query = { 'ifLargeUsers': 2 }
      this.selectedRows = []
      this.queryList()
    },
    // 模态框取消
    handleCancel () {
      this.alarmSettingsVisible = false;
      this.addOrUpdateForm.resetFields();
    },
    //统一报警设置
    alarmSettingsList () {
      if (this.selectedRows.length == 0) {
        this.$message.warning('请选择需要设置的用户');
      } else {
        this.alarmSettingsVisible = true;
        this.alarmSettings = 1
      }
    },

    //报警设置
    alarmSettingsById (item) {
      this.alarmSettingsVisible = true;
      this.id = item.id;
      this.alarmSettings = 2
      // 使用 $nextTick 确保模态框已经渲染
      this.$nextTick(() => {
        this.addOrUpdateForm.setFieldsValue({
          positiveFluctuations: item.positiveFluctuations || '',
          antiVolatility: item.antiVolatility || ''
        });
      });
    },
    alarmSettingsOk () {
      // 先进行表单验证
      this.addOrUpdateForm.validateFields((err, values) => {
        if (err) {
          console.log('表单验证失败:', err);
          return;
        }

        // 验证成功，获取表单值
        this.formValues = values;

        let data = []
        if (this.alarmSettings == 2) { //单独设置报警
          data.push({
            id: this.id,
            ...this.formValues,
            alarmSettings: this.alarmSettings
          })
        } else { //统一设置报警
          this.selectedRows.forEach(item => {
            data.push({
              id: item,
              ...this.formValues,
              alarmSettings: this.alarmSettings
            })
          })
        }
        this.$http.put(this.addOrUpdateUrl, data).then((res) => {
          this.$message.success('设置成功');
          this.handleCancel();
          this.queryList(); // 刷新列表
        }).catch(error => {
          this.$message.error('设置失败');
          console.error(error);
        });
      });
    },
    userInfoById (item) {
      this.$router.push({
        path: '/bigusers/workbench/userAnalysis/WaterUseAnalysisPage',
        query: { userCode: item.userCode }
      })
    },
    exportHandles () {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`, {
        params: this.query,
        responseType: 'blob',
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        }
      })
        .then(response => {
          console.log('导出响应:', response);
          const blob = response.data;
          // 下载逻辑
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = this.exportFileName;
          link.click();
          window.URL.revokeObjectURL(url);

          this.$message.success('导出成功');
        })
        .catch(error => {
          console.log('导出失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.resetList();
          this.importLoading = false
        })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.proportion {
  font-size: 15px;
  font-weight: bold;
  display: block;
  margin-bottom: 10px;
}

.user-data {
  background-color: #f4f9ff;
  padding: 20px 50px;


  .custom-row-height {
    line-height: 3;
    /* 或你需要的行高值 */
  }

  .user-data-font {
    color: #949795;
  }
}
</style>
